export const requestedPathKey = 'requestedPathOnAutoLogout';

// Java's maximum integer value
export const API_MAX_LIMIT = 2147483647;
